export default (arr, func) => {
  const min = Math.min(...arr.map(func));
  return arr.find(item => func(item) === min);
};
